import { COLORS } from '../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')<{ hasBorder: boolean }>`
    display: flex;
    padding: 18px 20px;
    gap: 16px 20px;
    background-color: ${COLORS.neutral_00};
    align-items: flex-start;

    ${({ hasBorder }) => hasBorder && `border-bottom: 1px solid ${COLORS.neutral_10};`}
`;

const Cell = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const DateCell = styled(Cell)`
    width: 140px;
    gap: 8px;
    flex-shrink: 0;
`;

export const FormatCell = styled(Cell)`
    width: 200px;
    gap: 8px;
    align-items: flex-start;
    flex-shrink: 0;
`;

export const NameCell = styled(Cell)`
    flex-grow: 1;
    gap: 8px;
`;

export const ControlsCell = styled('div')`
    display: flex;
    margin-left: auto;
    gap: 8px;
    align-self: center;
    align-items: center;
`;
